/**
 * Wortsuche für die Picker in den Buchungsflows (#174, #182).
 *
 * Jedes eingegebene Wort muss im Suchtext vorkommen, Reihenfolge und
 * Groß-/Kleinschreibung sind egal. Reine Logik ohne DOM, damit sie im
 * Unit-Test ohne UI-Bibliotheken läuft.
 */
import { compareByNameThenCode, compareNaturalText } from "./naturalSort";

function words(search) {
    return (search || "").toLowerCase().split(/\s+/).filter(Boolean);
}

function positionHaystack(position, articles, compartments, serialsByPosition) {
    const a = articles[position.article_id];
    const c = compartments[position.compartment_id];
    const serials = serialsByPosition[position.id] || [];
    return [a?.name, a?.ean, a?.manufacturer_number, ...serials, c?.code, c?.name]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
}

/**
 * Bestands-Positionen: Suchtext = Artikelname, EAN, Hersteller-Nr.,
 * Seriennummern der Assets an der Position, Fach-Code, Fach-Name.
 * Sortierung: Artikelname natürlich, dann Fach-Name und Fach-Code.
 */
export function filterPositions(positions, search, articles, compartments, serialsByPosition = {}) {
    const ws = words(search);
    const rows = positions.filter((p) => {
        const hay = positionHaystack(p, articles, compartments, serialsByPosition);
        return ws.every((w) => hay.includes(w));
    });
    return rows.sort((x, y) => {
        const byName = compareNaturalText(
            articles[x.article_id]?.name || "",
            articles[y.article_id]?.name || ""
        );
        if (byName !== 0) return byName;
        return compareByNameThenCode(compartments[x.compartment_id], compartments[y.compartment_id]);
    });
}

/**
 * Seriennummern einer Position, die zu einem Suchwort passen -- damit der
 * Treffer zeigt, warum er gefunden wurde.
 */
export function matchedSerials(position, search, serialsByPosition) {
    const ws = words(search);
    if (ws.length === 0) return [];
    return (serialsByPosition[position.id] || []).filter((serial) =>
        ws.some((w) => serial.toLowerCase().includes(w))
    );
}

/**
 * Artikel (Stammdaten, z. B. Wareneingang): Suchtext = Name, EAN,
 * Hersteller-Nr. Sortierung natürlich nach Name.
 */
export function filterArticles(articles, search) {
    const ws = words(search);
    return articles
        .filter((a) => {
            const hay = [a.name, a.ean, a.manufacturer_number].filter(Boolean).join(" ").toLowerCase();
            return ws.every((w) => hay.includes(w));
        })
        .sort((x, y) => compareNaturalText(x.name || "", y.name || ""));
}
